import type { IUseCase } from '@/shared/contracts/use-case.contract';
import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';

import { CLUB_ENDPOINT, type ClubSlugRequest, type ClubStatement } from '../types/club';

export class GetClubStatementUseCase implements IUseCase<ClubSlugRequest, ClubStatement> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute({ slug }: ClubSlugRequest): Promise<ClubStatement> {
    if (!slug) throw new Error('Slug is required');

    return this.client.sendRequest<ClubStatement, never>({
      method: HttpMethod.GET,
      endpoint: `${CLUB_ENDPOINT(slug)}/statement`,
    });
  }
}
